import { render } from "./SecurityBlockOverlay.vue?vue&type=template&id=7e70640f&scoped=true"
import script from "./SecurityBlockOverlay.vue?vue&type=script&lang=js"
export * from "./SecurityBlockOverlay.vue?vue&type=script&lang=js"

import "./SecurityBlockOverlay.vue?vue&type=style&index=0&id=7e70640f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e70640f"]])

export default __exports__